module.exports = __webpack_public_path__ + "media/images/icon-fold-big@3x-d877e3cd76bb5db6c8b7bff5ee53a35a.png";